export const FETCH_DATA = "FETCH_DATA";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";
export const FETCH_ENDPOINTS = "FETCH_ENDPOINTS";
export const FETCH_ENDPOINT_SUCCESS = "FETCH_ENDPOINT_SUCCESS";
export const FETCH_ENDPOINT_FAILURE = "FETCH_ENDPOINT_FAILURE";
export const FETCH_BASIC_CONFIG_DATA = "FETCH_BASIC_CONFIG_DATA";
export const FETCH_BASIC_CONFIG_SUCCESS = "FETCH_BASIC_CONFIG_SUCCESS";
export const FETCH_BASIC_CONFIG_FAILURE = "FETCH_BASIC_CONFIG_FAILURE";
export const CHANGE_THEME = "CHANGE_THEME";
export const FETCH_PROGRAMS = "FETCH_PROGRAMS";
export const FETCH_SOURCES = "FETCH_SOURCES";
export const FETCH_RESOURCES = "FETCH_RESOURCES";
export const SHOW_LOADER = "SHOW_LOADER";
export const GET_MASTER_LIST = "GET_MASTER_LIST";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_USER_DETAILS_SUCCESS = "SET_USER_DETAILS_SUCCESS";
export const GET_MESSAGE_LIBRARY = "GET_MESSAGE_LIBRARY";
export const GET_MESSAGE_LIBRARY_SUCCESS = "GET_MESSAGE_LIBRARY_SUCCESS";
export const GET_MESSAGE_LIBRARY_FAILURE = "GET_MESSAGE_LIBRARY_FAILURE";
export const SET_SIDEBAR_OPEN_MENUS = "SET_SIDEBAR_OPEN_MENUS";
export const SET_SIDEBAR_SELECTED_MENU = "SET_SIDEBAR_SELECTED_MENU";
export const RESET_STATE = "RESET_STATE";
export const UPDATE_USERS_LIST = "UPDATE_USERS_LIST";
export const CLEAR_CACHE = "CLEAR_CACHE";
export const SET_CONSOLE_DATA = "SET_CONSOLE_DATA";
export const SET_UTS = "SET_UTS";
export const SET_MICRO_SERVICE_FLAG = "SET_MICRO_SERVICE_FLAG";
